import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventAttendeeTicketOrderParticipantStatus } from '@models/events/enums/event-attendee-ticket-status.enum';
import { EventAttendeeTicket } from '@models/events/event-attendee-ticket.model';
import { Event } from '@models/events/event.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-order-ticket-owner-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ticket-order-ticket-owner-card.component.html',
  styleUrl: './ticket-order-ticket-owner-card.component.scss',
})
export class TicketOrderTicketOwnerCardComponent {
  @Input() ticket!: EventAttendeeTicket;
  @Input() event?: Event;
  @Input() status?: EventAttendeeTicketOrderParticipantStatus;

  @Output() forwardTicket = new EventEmitter<EventAttendeeTicket>();
  @Output() viewData = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  get notClaimed() {
    return (
      this.status === EventAttendeeTicketOrderParticipantStatus.NOT_CLAIMED
    );
  }

  get notAssigned() {
    return this.status === EventAttendeeTicketOrderParticipantStatus.UNASSIGNED;
  }
  onViewData() {
    this.viewData.emit();
  }

  onForwardTicket() {
    this.forwardTicket.emit(this.ticket);
  }
}
